<a href="javascript:void(0)" (click)="action()">
  {{ text }}
</a>
